module.exports = __webpack_public_path__ + "media/images/brainsparks-15b7d2a754a37c4bd50eb7fb3e7a5f37.png";